// 조직·세션 액션(rpc) — 로그인 성공은 봉투의 session 을 setSession 한 뒤 /app 으로 던진다(D4).
import type { CodeEntry } from "@buildpy/core/modules/org/codes";
import type { InviteInput } from "@buildpy/core/modules/org/invite-action-types";
import type { MarginSettingsInput, PriceEditRow, PriceSettingsInput } from "@buildpy/core/modules/org/action-types";

import { rpc } from "@/api/client";
import { settleRedirect } from "@/lib/redirect-error";

export const signIn = (form: FormData) => rpc("org/actions/signIn", form);

export const acceptInvite = (token: string, form: FormData) => rpc("org/actions/acceptInvite", token, form);

// 초안 지우기는 봉투의 세션 clear 를 받는 client.ts onSession 한 곳에서 · /login 이동은 onRedirect 가 했으니 RpcRedirect 는 삼킨다(폼 action 에서 던지면 오류 경계·콘솔로 샌다).
export const logout = async (): Promise<void> => {
  try {
    await rpc("org/session/logout");
  } catch (caught) {
    if (!settleRedirect(caught)) throw caught;
  }
};

// 설정 화면(G2c) — 회사·단가·초대·브랜드·코드값·계약·간편접수·시공사례 공개·하자보수 저장.
export const saveOrgSettings = (form: FormData) => rpc("org/actions/saveOrgSettings", form);

// 조직 탈퇴 — 대표가 조직 이름·비밀번호를 다시 쳐서 바로 해지(복구는 90일 안 메일).
export const leaveOrg = (input: { name: string; password: string }) => rpc("org/leave-actions/leaveOrg", input);

export const savePrices = (rows: PriceEditRow[]) => rpc("org/actions/savePrices", rows);

export const saveMarginSettings = (input: MarginSettingsInput) => rpc("org/actions/saveMarginSettings", input);

// 단가표 탭 저장 한 번 — 마진과 단가 줄을 한 트랜잭션으로(rpc_price_settings_save).
export const savePriceSettings = (input: PriceSettingsInput) => rpc("org/actions/savePriceSettings", input);

export const createInvite = (input: InviteInput) => rpc("org/actions/createInvite", input);

export const revokeInvite = (inviteId: string) => rpc("org/actions/revokeInvite", inviteId);

export const saveBrandFooter = (input: unknown) => rpc("org/brand-settings-actions/saveBrandFooter", input);

export const saveCodes = (key: string, entries: CodeEntry[]) => rpc("org/codes-actions/saveCodes", key, entries);

export const saveContractSettings = (input: unknown) => rpc("org/contract-settings-actions/saveContractSettings", input);

export const saveIntakeDesignerChoice = (input: unknown) => rpc("org/intake-settings-actions/saveIntakeDesignerChoice", input);

export const saveIntakeMode = (input: unknown) => rpc("org/intake-settings-actions/saveIntakeMode", input);

export const saveMemberIntake = (input: unknown) => rpc("org/intake-settings-actions/saveMemberIntake", input);

export const savePortfolioPublicPage = (input: unknown) => rpc("org/portfolio-settings-actions/savePortfolioPublicPage", input);

export const savePortfolioPublicInquiry = (input: unknown) => rpc("org/portfolio-settings-actions/savePortfolioPublicInquiry", input);

export const saveProjectWarrantyEnabled = (input: unknown) => rpc("org/project-settings-actions/saveProjectWarrantyEnabled", input);

export const saveCostAccess = (input: unknown) => rpc("org/cost-settings-actions/saveCostAccess", input);
export const saveProcessCalibration = (input: unknown) => rpc("org/process-settings-actions/saveProcessCalibration", input);
